import * as PaykrubTransferOutAddService from '@/services/apis/paykrubTransferOutAdd'
const state = {}

const actions = {
  // async getSpadeHighData({ }, params) {
  //   try {
  //     const res = await PaykrubTransferOutAddService.getSpadeHighData(params)
  //     return res.data
  //   } catch (err) {
  //     if (err.message) {
  //       throw JSON.parse(err.message)
  //     }
  //   }
  // },

  // async saveSpadeHighData({ }, params) {
  //   try {
  //     const res = await PaykrubTransferOutAddService.saveSpadeHighData(params)
  //     return res.data
  //   } catch (err) {
  //     if (err.message) {
  //       throw JSON.parse(err.message)
  //     }
  //   }
  // },
}

export default {
  state,
  actions,
}
